




import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { soundPlay, SoundFileName } from "@/services/sound";
import { SoundSettingvalues } from "../../services/settings";
import { JinroGameDocument } from "../../services/datatypes";
import JinroGame from "../JinroPlayer/JinroGame.vue";
import { JinroPlayStatus } from "../../services/jinro-play-status";
import { DEFAULT_SOUND_VOLUME } from "../../services/constants";

@Component({})
export default class SoundEffect extends Vue {
  @Prop() readonly jinroGame!: JinroGameDocument;

  get isNextPlayQueueProcessing(): boolean {
    if (!this.jinroGame) {
      return false;
    }
    return this.jinroGame.isNextPlayQueueProcessing;
  }

  @Watch("isNextPlayQueueProcessing")
  onChange() {
    if (!this.isNextPlayQueueProcessing) {
      return;
    }
    this.playSceneChaningSound();
  }

  playSceneChaningSound() {
    const isSoundPlayable = this.isSoundPlayable;
    if (!isSoundPlayable) {
      return;
    }
    this.playSceneChaningBaseSound();
    this.playSceneChaningSpecialSound();
  }

  get soundVolume(): number {
    return this.$store.state.soundSettingVolume;
  }

  async playSceneChaningBaseSound() {
    await soundPlay(SoundFileName.sceneChangingBaseSound, this.soundVolume);

    return;
  }

  async playSceneChaningSpecialSound() {
    const currentJinroStatus = this.jinroGame.currentPlayStatus;
    if (!currentJinroStatus) {
      return;
    }
    const birdSoundNeededArry = [
      JinroPlayStatus.Prologue,
      JinroPlayStatus.AfterNight
    ];
    if (birdSoundNeededArry.includes(currentJinroStatus)) {
      await soundPlay(SoundFileName.birdSingingSound, this.soundVolume);
    }

    return;
  }

  get isSoundPlayable(): boolean {
    if (!this.$store.state.soundSetting) {
      return false;
    }
    return this.$store.state.soundSetting === SoundSettingvalues.ON;
  }
}
